export const SESSION = {
  HEADER_NAME: process.env.REACT_APP_SESSION_HEADER || '',
  COOKIE_NAME: process.env.REACT_APP_SESSION_COOKIE_NAME || '',
  COOKIE_LIFETIME: process.env.REACT_APP_SESSION_LIFETIME || '',
  COOKIE_DOMAIN: process.env.REACT_APP_SESSION_COOKIE_DOMAIN || '',
};
